import { render, staticRenderFns } from "./AbstractPaginaGestione.vue?vue&type=template&id=7e15f876&scoped=true&lang=pug"
import script from "./AbstractPaginaGestione.vue?vue&type=script&lang=ts"
export * from "./AbstractPaginaGestione.vue?vue&type=script&lang=ts"
import style0 from "./AbstractPaginaGestione.vue?vue&type=style&index=0&id=7e15f876&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e15f876",
  null
  
)

export default component.exports